export default {
    topics: [
        {
            title: ' PrepareFusion ',
            href: 'sm-fusion-PrepareFusion.html',
            attributes: { 'data-id': 'sm-fusion-PrepareFusion' },
            menu: { hasChildren: false },
            tocID: 'sm-fusion-PrepareFusion-d66e689',
            topics: [],
        },
        {
            title: ' ProcessFusion ',
            href: 'sm-fusion-ProcessFusion.html',
            attributes: { 'data-id': 'sm-fusion-ProcessFusion' },
            menu: { hasChildren: false },
            tocID: 'sm-fusion-ProcessFusion-d66e697',
            topics: [],
        },
    ],
};

